import type { ZustandStore } from '../store.type';
import type { NewCodingEntry } from './codingEntrySlice';
import type { NamedSet } from 'zustand/middleware';

export type CodingListElement = { name?: string | undefined; id: string; code?: string | undefined; enabled: boolean };
export type SelectedCodingEntries = {
	code: string;
	values: NewCodingEntry[];
};

type CodingListState = {
	codingList: {
		currentCodingListSelected: CodingListElement;
		selectedCodingEntries: SelectedCodingEntries;
	};
};

type CodingListActions = {
	setCurrentCodingListSelected: (
		currentCodingListSelected: CodingListState['codingList']['currentCodingListSelected'],
	) => void;
	setCurrentCodingListSelectedName: (name: CodingListState['codingList']['currentCodingListSelected']['name']) => void;
	setSelectedCodingEntries: (selectedCodingEntries: CodingListState['codingList']['selectedCodingEntries']) => void;
	resetCurrentCodingListSelected: () => void;
};

export type CodingListSlice = CodingListState & CodingListActions;

const codingListInitialState: CodingListState = {
	codingList: {
		currentCodingListSelected: { name: '', id: '', code: '', enabled: false },
		selectedCodingEntries: { code: '', values: [] },
	},
};

export function codingListSlice(set: NamedSet<ZustandStore>): CodingListSlice {
	return {
		...codingListInitialState,
		setCurrentCodingListSelected(
			currentCodingListSelected: CodingListState['codingList']['currentCodingListSelected'],
		): void {
			set(
				(state: CodingListState) => {
					state.codingList.currentCodingListSelected.id =
						currentCodingListSelected.id ?? state.codingList.currentCodingListSelected.id;
					state.codingList.currentCodingListSelected.name =
						currentCodingListSelected.name ?? state.codingList.currentCodingListSelected.name;
					state.codingList.currentCodingListSelected.code =
						currentCodingListSelected.code ?? state.codingList.currentCodingListSelected.code;
					state.codingList.currentCodingListSelected.enabled =
						currentCodingListSelected.enabled ?? state.codingList.currentCodingListSelected.enabled;
					return state;
				},
				false,
				'[setCurrentCodingListSelected]',
			);
		},
		resetCurrentCodingListSelected(): void {
			set(
				(state: CodingListState) => {
					state.codingList.currentCodingListSelected = { name: '', id: '', code: '', enabled: false };
					return state;
				},
				false,
				'[resetCurrentCodingListSelected]',
			);
		},
		setSelectedCodingEntries(selectedCodingEntries: CodingListState['codingList']['selectedCodingEntries']): void {
			set(
				(state: CodingListState) => {
					state.codingList.selectedCodingEntries = selectedCodingEntries;
					return state;
				},
				false,
				'[setSelectedCodingEntries]',
			);
		},
		setCurrentCodingListSelectedName(name: CodingListState['codingList']['currentCodingListSelected']['name']): void {
			set(
				(state: CodingListState) => {
					state.codingList.currentCodingListSelected.name = name || state.codingList.currentCodingListSelected.name;
					return state;
				},
				false,
				'[setSelectedCodingEntries]',
			);
		},
	};
}
